export const ANIMATE_DURATION = 200; // ms
